import { ThemeProvider } from '@material-ui/core';
import React from 'react';

import { lightTheme } from '../light';

export const AdminThemeContainer = ({ children }: { children: React.ReactNode }) => {
    return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>;
};
